import { useContext } from 'react';
import { ReportContext } from '../../../context/ReportContext';
import SimpleDataGrid from '../../Tables/SimpleDataGrid';
import SimpleDataGridItem from '../../Tables/SimpleDataGridItem';
import ExpandableInfoCard, {
    ExpandableInfoCardDescription,
    ExpandableInfoCardDetail,
} from '../../Cards/ExpandableInfoCard';

const UserIngressAggregate = () => {
    const { reportData } = useContext(ReportContext);
    const data = reportData || {};

    return (
        <div className="space-y-6">
            <SimpleDataGrid>
                <SimpleDataGridItem
                    label="Total Registrations:"
                    value={data.totalRegistrations}
                />
                <SimpleDataGridItem label="Total Logins:" value={data.totalLogins} />
                <SimpleDataGridItem
                    label="Total Unique Logins:"
                    value={data.totalDistinctLogins}
                />
            </SimpleDataGrid>

            <ExpandableInfoCard title="What is this data?">
                <ExpandableInfoCardDescription>
                    This report provides an aggregate view of user registration and login
                    activity within the platform for the selected time period and filters.
                </ExpandableInfoCardDescription>
                <ExpandableInfoCardDetail name="Total Registrations">
                    The total number of users who completed their registration and created
                    their account, either by manual account creation or initial login by
                    SSO.
                </ExpandableInfoCardDetail>
                <ExpandableInfoCardDetail name="Total Logins">
                    The total number of login events, including multiple logins by the
                    same user. The user's initial registration also counts as a login.
                </ExpandableInfoCardDetail>
                <ExpandableInfoCardDetail name="Total Unique Logins">
                    The number of distinct users who logged in at least once during the
                    selected time period.
                </ExpandableInfoCardDetail>
            </ExpandableInfoCard>
        </div>
    );
};

export default UserIngressAggregate;
